(() => {
  if (window.__priceMatchInit) return;
  window.__priceMatchInit = true;

  const modal = document.getElementById("priceMatchModal");
  const contentEl = document.getElementById("priceMatchContent");
  const loadingEl = document.getElementById("priceMatchLoading");

  // ----------------- helpers: styles & cleanup -----------------
  function ensurePmStyles() {
    if (document.getElementById("pm-clean-styles")) return;
    const css = `
    #priceMatchContent.pm-clean, #priceMatchContent.pm-clean * { text-align: left; }
    #priceMatchContent.pm-clean p{ margin: .75rem 0; }
    #priceMatchContent.pm-clean ul,
    #priceMatchContent.pm-clean ol{ margin: .75rem 0 .75rem 1.25rem; padding-left: 1.25rem; }
    #priceMatchContent.pm-clean li{ margin: .35rem 0; }

    #priceMatchContent.pm-clean .text-center{ text-align:left !important; }
    #priceMatchContent.pm-clean [style*="text-align:center"]{ text-align:left !important; }

    #priceMatchContent .breadcrumb,
    #priceMatchContent .breadcrumbs,
    #priceMatchContent nav.breadcrumb,
    #priceMatchContent nav[aria-label*="breadcrumb" i]{
      display:none !important;
    }
    
    #priceMatchContent header.page__header.page__header--stack.page__header--centered {
      margin: 0 auto;
    }

    #priceMatchContent .page__sub-header {
      display: none !important;
    }
    `;
    const s = document.createElement("style");
    s.id = "pm-clean-styles";
    s.textContent = css;
    document.head.appendChild(s);
  }

  function tidyPriceMatchDom(root) {
    root
      .querySelectorAll(
        '.breadcrumb, .breadcrumbs, nav.breadcrumb, nav[aria-label*="breadcrumb" i]'
      )
      .forEach((el) => el.remove());

    const titleNorm = (s) =>
      (s || "").trim().toLowerCase().replace(/\s+/g, " ");
    const DUP_TEXT = "seen it lower?";
    root.querySelectorAll("h1, h2, .page-title").forEach((h) => {
      if (titleNorm(h.textContent) === DUP_TEXT) h.remove();
    });
    const firstEl = root.firstElementChild;
    if (firstEl && /H1|H2/i.test(firstEl.tagName)) firstEl.remove();

    root.querySelectorAll("p").forEach((p) => {
      const t = titleNorm(p.textContent);
      if (/home\s*[›\/>]/.test(t) || t === DUP_TEXT) p.remove();
    });

    root.querySelectorAll('[style*="text-align"]').forEach((n) => {
      n.style.textAlign = "left";
    });
  }

  window.PM = {
    open: (url = "/pages/request-a-price") => {
      openModal(url);
      loadIntoModal(url);
    },
    close: () => closeModal(),
  };

  function openModal(url) {
    if (!modal) return;
    if (url) modal.dataset.pmUrl = url;

    modal.classList.remove("ab:hidden");
    modal.setAttribute("aria-hidden", "false");

    contentEl && contentEl.classList.remove("ab:hidden");
    loadingEl && loadingEl.classList.add("ab:hidden");

    const chatBtn = document.getElementById("chatWithUsBtn");
    if (chatBtn && !chatBtn.__pmBound) {
      chatBtn.addEventListener("click", (e) => {
        e.preventDefault();
        openChatWindow();
      });
      chatBtn.__pmBound = true;
    }
    const formBtn = document.getElementById("priceMatchFormBtn");
    if (formBtn) {
      const formUrl = modal.dataset.pmUrl || "/pages/request-a-price";
      formBtn.setAttribute("href", formUrl);
    }
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.add("ab:hidden");
    modal.setAttribute("aria-hidden", "true");
    contentEl && contentEl.classList.add("ab:hidden");
    loadingEl && loadingEl.classList.remove("ab:hidden");
  }

  function openChatWindow() {
    try {
      if (window.Shopify?.chat?.toggle) {
        window.Shopify.chat.toggle(true);
        return;
      }
      if (window.GorgiasChat?.open) {
        window.GorgiasChat.open();
        return;
      }
      if (window.Intercom) {
        window.Intercom("show");
        return;
      }
      if (window.zE) {
        try {
          window.zE("messenger", "open");
          return;
        } catch (_) {}
        try {
          window.zE("webWidget", "open");
          return;
        } catch (_) {}
      }
      if (window.tidioChatApi?.open) {
        window.tidioChatApi.open();
        return;
      }
      const btn = document.querySelector(
        '[data-chat-launch], .chat-launcher, #chat-widget, [aria-label*="chat" i]'
      );
      if (btn) btn.click();
    } catch (_) {}
  }

  function replaceFormsWithChatButton(scope) {
    const formUrl = modal?.dataset?.pmUrl || "#";
    scope.querySelectorAll("form").forEach((form) => {
      const wrap = document.createElement("div");
      wrap.className =
        "ab:mt-6 ab:flex ab:items-center ab:justify-center ab:flex-wrap ab:gap-3";

      const chatBtn = document.createElement("button");
      chatBtn.type = "button";
      chatBtn.className =
        "ab:inline-flex! ab:items-center! ab:justify-center! " +
        "ab:rounded-lg! ab:bg-green-600! ab:px-6! ab:py-3! " +
        "ab:text-white! ab:heading-xs_xl! " +
        "ab:hover:bg-green-700! ab:focus:outline-none! " +
        "ab:focus:ring-2! ab:focus:ring-green-600/50!";
      chatBtn.textContent = "💬 Chat with Us Now";
      chatBtn.addEventListener("click", (e) => {
        e.preventDefault();
        openChatWindow();
      });

      const formLink = document.createElement("a");
      formLink.href = formUrl;
      formLink.target = "_self";
      formLink.className =
        "ab:inline-flex! ab:items-center! ab:justify-center! " +
        "ab:rounded-lg! ab:border! ab:border-gray-300! ab:px-6! ab:py-3! " +
        "ab:text-gray-700! ab:heading-xs_xl! " +
        "ab:hover:bg-gray-50! ab:focus:outline-none! " +
        "ab:focus:ring-2! ab:focus:ring-gray-300/50!";
      formLink.textContent = "📝 Fill out the form";

      wrap.append(chatBtn, formLink);
      form.replaceWith(wrap);
    });
  }

  function extractUsefulContent(htmlText) {
    const doc = new DOMParser().parseFromString(htmlText, "text/html");
    const selectors = [
      "[data-price-match-content]",
      "#PriceMatchContent",
      "#MainContent",
      "main",
      ".page-width",
      ".shopify-section",
    ];
    for (const sel of selectors) {
      const node = doc.querySelector(sel);
      if (node && node.innerHTML.trim()) return node;
    }
    return doc.body;
  }

  async function loadIntoModal(url) {
    try {
      loadingEl && loadingEl.classList.remove("ab:hidden");
      contentEl && contentEl.classList.add("ab:hidden");

      const res = await fetch(url, { credentials: "same-origin" });
      if (!res.ok) throw new Error("Network error " + res.status);

      const txt = await res.text();
      const node = extractUsefulContent(txt);
      // Find the target text (case- and punctuation-insensitive) and replace it
      if (node && typeof node.innerHTML === "string") {
        node.innerHTML = node.innerHTML.replace(
          /Please fill out the form below and we’ll get back to you as soon as possible\./gi,
          ""
        );
        const newDiv = document.createElement("div");
        newDiv.className =
          "ab:border! ab:border-gray-200! ab:rounded-xl! ab:p-4! ab:pt-2! ab:bg-white! ab:shadow-sm!";
        newDiv.innerHTML = `
          <p class="ab:text-md!  ab:text-[#101828]! ab:m-0! ab:mb-2!">Please <strong>copy</strong> content below and <strong>paste</strong> it in <strong>Chat window</strong></p>
          <textarea id="priceMatchText" 
            class="ab:w-full! ab:p-3! ab:font-mono! ab:text-sm! ab:border! ab:border-gray-300! ab:rounded-lg! ab:bg-gray-50! ab:focus:outline-none! ab:focus:ring-2! ab:focus:ring-blue-500! ab:resize-none!"
            rows="3">I’d like to request a price match.
Link to lower price: </textarea>
          <button 
            onclick="navigator.clipboard.writeText(document.getElementById('priceMatchText').value)" 
            class="ab:mt-3! ab:p-2! ab:px-4! ab:rounded-lg! ab:bg-gray-600! ab:text-white! ab:font-medium! ab:hover:bg-gray-700! ab:active:bg-gray-800!">
            Copy Message
          </button>
        `;

        const pageDescription = node.querySelector(".page__description.rte");
        if (pageDescription) {
          pageDescription.append(newDiv);
        }
      }

      const dom = node.cloneNode(true);

      ensurePmStyles();
      tidyPriceMatchDom(dom);

      replaceFormsWithChatButton(dom);

      dom.querySelectorAll("a[href]").forEach((a) => {
        a.setAttribute("target", "_blank");
        a.setAttribute("rel", "noopener");
      });

      if (contentEl) {
        contentEl.classList.add("pm-clean");
        contentEl.innerHTML = "";
        contentEl.appendChild(dom);
      }
      loadingEl && loadingEl.classList.add("ab:hidden");
      contentEl && contentEl.classList.remove("ab:hidden");
    } catch (e) {
      window.location.href = url;
    }
  }

  function triggerHandler(evt) {
    const el = evt.target.closest("[data-pm-link], .request-price");
    if (!el) return;
    if (evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.button === 1) return;

    evt.preventDefault();
    evt.stopPropagation?.();
    evt.stopImmediatePropagation?.();

    const url = el.getAttribute("data-pm-url") || el.getAttribute("href");
    if (!url) return;

    openModal(url);
    loadIntoModal(url);
  }

  document.addEventListener("click", triggerHandler, true);
  document.addEventListener("mousedown", triggerHandler, true);
  document.addEventListener("touchstart", triggerHandler, {
    capture: true,
    passive: false,
  });

  modal?.addEventListener("click", (e) => {
    if (e.target.closest("[data-pm-close]")) {
      e.preventDefault();
      closeModal();
    }
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modal && !modal.classList.contains("ab:hidden"))
      closeModal();
  });
})();
